import React from "react";
import { List, Typography } from "antd";
import dayjs from "dayjs";
import { UserOutlined } from "@ant-design/icons";

const HistoryContent = ({ history }) => {
  return (
    <List
      bordered
      dataSource={history}
      renderItem={(item) => (
        <List.Item>
          <List.Item.Meta
            avatar={<UserOutlined />}
            title={item.actionType === 'Pending'
              ? `${item.actionType} ${item.performedBy ? `Review from ${item.performedBy.firstName} ${item.performedBy.lastName}` : ''}`
              : `${item.actionType} ${item.performedBy ? `by ${item.performedBy.firstName} ${item.performedBy.lastName}` : ''}`}
            description={`On ${dayjs(item.actionDate).format("DD MMM YYYY")}`}
          />
          {item.comments}
        </List.Item>
      )}
    />
  );
};

export default HistoryContent;
